import { getGrantedSubAccounts } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';
/**
 * Fetches the user's sub-account names and associated roles, grouped by associated group 
 */
const GetGrantedSubAccounts = async (accessToken) => {
  try {
    const response = await getGrantedSubAccounts(accessToken);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: extractApiErrorMessage(error) };
  }
};

export default GetGrantedSubAccounts;
